function loadView(view) {
  // which is lazy-loaded when the route is visited.
  return () => import(`@/views/${view}.vue`);
}
import Setting from "@/views/settings/base/main.vue";
export default [
  {
    path: "/register",
    name: "register",
    authName: "register",
    txtName: "注册",
    component: loadView("register/index"),
  },
  {
    path: "/index",
    alias: "",
    component: loadView("index"),
  },
  {
    path: "/customer-home",
    authName: "home",
    name: "customer-home",
    component: loadView("home-customer/index"),
    children: [
      {
        path: "",
        name: "videolist",
        authName: "home",
        txtName: "首页",
        component: loadView("home-customer/subviews/video-list"),
      },
      {
        path: "videodetail",
        name: "videodetail",
        authName: "home",
        txtName: "客户视频详情页",
        component: loadView("home-customer/subviews/video-detail"),
      },
    ],
  },
  //账号设置
  {
    path: "/setting",
    name: "setting",
    authName: "setting",
    txtName: "账号设置",
    component: Setting,
    children: [
      {
        path: "",
        name: "index",
        authName: "index",
        txtName: "标签页导航",
        component: loadView("settings/index/settings"),
      },
    ],
  },
  // 首页
  {
    path: "/home",
    redirect: "homeindex",
    name: "home",
    authName: "home",
    txtName: "首页",
    component: loadView("homepage/base/main"),
    children: [
      {
        path: "/homeindex",
        name: "homeIndex",
        authName: "homeIndex",
        txtName: "首页默认页",
        meta: {
          activeInx: "0",
          activeName: "/home",
        },
        component: loadView("homepage/index/index"),
      },
      {
        path: "guide",
        name: "guide",
        authName: "guide",
        txtName: "常见问题/操作手册/意见反馈",
        meta: {
          activeInx: "0",
          activeName: "/home",
        },
        component: loadView("homepage/index/guide"),
      },
      {
        path: "newsList",
        name: "newsList",
        authName: "newsList",
        txtName: "新闻公告列表页",
        meta: {
          activeInx: "4",
          activeName: "news",
        },
        component: loadView("homepage/index/news-list"),
      },
      {
        path: "newsDetail",
        name: "newsDetail",
        authName: "newsDetail",
        txtName: "新闻公告详情页",
        meta: {
          activeInx: "4",
          activeName: "news",
        },
        component: loadView("homepage/index/news-detail"),
      },
      {
        path: "resource",
        name: "resource",
        authName: "resource",
        txtName: "资源",
        meta: {
          activeInx: "1",
          activeName: "resource",
        },
        component: loadView("homepage/resource/resource"),
      },
      {
        path: "resourceList",
        name: "resourceList",
        authName: "resourceList",
        txtName: "学科资源列表页",
        meta: {
          activeInx: "1",
          activeName: "resource",
        },
        component: loadView("homepage/resource/resource-list"),
      },
      {
        path: "resourceDetail",
        name: "resourceDetail",
        authName: "resourceDetail",
        txtName: "学科资源详情页",
        meta: {
          activeInx: "1",
          activeName: "resource",
        },
        component: loadView("homepage/resource/resource-detail"),
      },
      {
        path: "resourceSharePage",
        name: "resourceSharePage",
        authName: "resourceSharePage",
        txtName: "学科资源分享页",
        meta: {
          activeInx: "1",
          activeName: "resource",
        },
        component: loadView("homepage/resource/resource-detail"),
        // component: loadView("homepage/resource/resource-sharePage"),
      },
      {
        path: "albumList",
        name: "albumList",
        authName: "albumList",
        txtName: "优课专辑列表页",
        meta: {
          activeInx: "5",
          activeName: "albumList",
        },
        component: loadView("homepage/resource/album-list"),
      },
      {
        path: "albumDetail",
        name: "albumDetail",
        authName: "albumDetail",
        txtName: "优课专辑详情页",
        meta: {
          activeInx: "5",
          activeName: "albumList",
        },
        component: loadView("homepage/resource/album-detail"),
      },

      {
        path: "albumSharePage",
        name: "albumSharePage",
        authName: "albumSharePage",
        txtName: "优课专辑分享页",
        meta: {
          activeInx: "5",
          activeName: "albumList",
        },
        component: loadView("homepage/resource/album-sharePage"),
      },
      {
        path: "albumPaper",
        name: "albumPaper",
        authName: "albumPaper",
        txtName: "优课专辑试卷",
        meta: {
          activeInx: "5",
          activeName: "albumList",
        },
        component: loadView("homepage/resource/album-paper"),
      },
      // {
      //     path: "course",
      //     name: "course",
      //     authName: "course",
      //     txtName: "课程",
      //     meta: { activeInx: "3", activeName: 'openclass'},
      //     component: loadView("homepage/course/course")
      // },
      {
        path: "liveList",
        name: "liveList",
        authName: "liveList",
        txtName: "直播列表页",
        meta: { activeInx: "2", activeName: "live" },
        component: loadView("homepage/course/live-list"),
      },
      {
        path: "liveRoom",
        name: "liveRoom",
        authName: "liveRoom",
        txtName: "直播间",
        meta: { activeInx: "2", activeName: "live" },
        component: loadView("homepage/course/live-room"),
      },
      {
        path: "liveSharePage",
        name: "liveSharePage",
        authName: "liveSharePage",
        txtName: "直播间",
        meta: { activeInx: "2", activeName: "live" },
        component: loadView("homepage/course/live-sharePage"),
      },
      {
        path: "openclassList",
        name: "openclassList",
        authName: "openclassList",
        txtName: "公开课列表页",
        meta: { activeInx: "3", activeName: "openclass" },
        component: loadView("homepage/course/openclass-list"),
      },
      {
        path: "openclassDetail",
        name: "openclassDetail",
        authName: "openclassDetail",
        txtName: "公开课详情页",
        meta: { activeInx: "3", activeName: "openclass" },
        component: loadView("homepage/course/openclass-detail"),
      },
      {
        path: "openclassSharePage",
        name: "openclassSharePage",
        authName: "openclassSharePage",
        txtName: "公开课分享页",
        meta: { activeInx: "3", activeName: "openclass" },
        // component: loadView("homepage/course/openclass-sharePage"),
        component: loadView("homepage/course/openclass-detail"),
      },
      {
        path: "studyList",
        name: "studyList",
        authName: "studyList",
        txtName: "学习任务列表页",
        meta: { activeInx: "6", activeName: "study" },
        component: loadView("homepage/course/study-list"),
      },
      {
        path: "studyDetail",
        name: "studyDetail",
        authName: "studyDetail",
        txtName: "学习任务详情页",
        meta: {
          activeInx: "6",
          activeName: "studyList",
        },
        component: loadView("homepage/resource/study-detail"),
      },
      {
        path: "studyVideo",
        name: "studyVideo",
        authName: "studyVideo",
        txtName: "学习任务详情页",
        meta: {
          activeInx: "6",
          activeName: "studyList",
        },
        component: loadView("homepage/course/study-video"),
      },
      {
        path: "map",
        name: "map",
        authName: "map",
        txtName: "成长地图页",
        meta: { activeInx: "7", activeName: "map" },
        component: loadView("homepage/map/index"),
      },
      {
        path: "mapLevel",
        name: "mapLevel",
        authName: "mapLevel",
        txtName: "成长地图关卡详情页",
        meta: { activeInx: "7", activeName: "mapLevel" },
        component: loadView("homepage/map/level"),
      },
      {
        path: "taskVideo",
        name: "taskVideo",
        authName: "taskVideo",
        txtName: "任务视频详情页",
        meta: { activeInx: "7", activeName: "taskVideo" },
        component: loadView("homepage/taskVideo/video-detail"),
      },
      {
        path: "leaderList",
        name: "leaderList",
        authName: "leaderList",
        txtName: "高层讲堂",
        meta: { activeInx: "8", activeName: "leaderList" },
        component: loadView("homepage/resource/leader-list"),
      },
      {
        path: "bigorderList",
        name: "bigorderList",
        authName: "bigorderList",
        txtName: "百万大单",
        meta: { activeInx: "9", activeName: "bigorderList" },
        component: loadView("homepage/resource/bigorder-list"),
      },
      {
        path: "caseList",
        name: "caseList",
        authName: "caseList",
        txtName: "案例中心",
        meta: { activeInx: "10", activeName: "caseList" },
        component: loadView("homepage/404"),
      },
      {
        path: "caseList",
        name: "caseList",
        authName: "caseList",
        txtName: "案例中心",
        meta: { activeInx: "10", activeName: "caseList" },
        component: loadView("homepage/404"),
      },
      {
        path: "lecturerList",
        name: "lecturerList",
        authName: "lecturerList",
        txtName: "讲师中心",
        meta: { activeInx: "11", activeName: "lecturerList" },
        component: loadView("homepage/404"),
      },
      // {
      //     path: "app",
      //     name: "app",
      //     authName: "app",
      //     txtName: "应用",
      //     meta: { activeInx: "3", },
      //     component: loadView("homepage/app/app")
      // }
    ],
  },
  // 登录
  {
    path: "/user-login",
    // alias: '',
    name: "user-login",
    authName: "user-login",
    txtName: "用户登录",
    component: loadView("login/index"),
  },
  {
    path: "/cdkey",
    name: "cdkey",
    authName: "cdkey",
    txtName: "系统过期激活",
    component: loadView("homepage/index/cdkey"),
  },
  // //个人空间
  // {
  //     path: "/space",
  //     name: "space",
  //     authName: "space",
  //     txtName: "个人空间",
  //     component: loadView("space/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "index",
  //             authName: "index",
  //             txtName: "个人空间",
  //             component: loadView("space/index/index"),
  //             children: [
  //                 {
  //                     path: "video",
  //                     name: "video",
  //                     authName: "video",
  //                     txtName: "TA的视频",
  //                     component: loadView("space/index/video")
  //                 },
  //                 {
  //                     path: "resource",
  //                     name: "resource",
  //                     authName: "resource",
  //                     txtName: "TA的资源",
  //                     component: loadView("space/index/resource")
  //                 },
  //                 {
  //                     path: "journal",
  //                     name: "journal",
  //                     authName: "journal",
  //                     txtName: "TA的日志",
  //                     component: loadView("space/index/journal")
  //                 },
  //                 {
  //                     path: "fans",
  //                     name: "fans",
  //                     authName: "fans",
  //                     txtName: "TA的粉丝",
  //                     component: loadView("space/index/fans")
  //                 },
  //                 {
  //                     path: "follow",
  //                     name: "follow",
  //                     authName: "follow",
  //                     txtName: "TA的关注",
  //                     component: loadView("space/index/follow")
  //                 }
  //             ]
  //         },
  //         {
  //             path: "journal-detail",
  //             name: "detail",
  //             authName: "detail",
  //             txtName: "个人空间--日志",
  //             component: loadView("space/index/journal-detail")
  //         }
  //     ]
  // },

  //教师培训
  // {
  //     path: "/train",
  //     name: "train",
  //     authName: "train",
  //     txtName: "教师培训-首页",
  //     component: loadView("train/base/main"),
  //     children: [
  //         {
  //             path: "/",
  //             name: "index",
  //             authName: "index",
  //             txtName: "教师培训",
  //             component: loadView("train/index/index")
  //         },
  //         {
  //             path: "manage",
  //             name: "manage",
  //             authName: "manage",
  //             txtName: "培训管理",
  //             component: loadView("train/index/train-list"),
  //             children: [
  //                 {
  //                     path: "index",
  //                     name: "index",
  //                     authName: "index",
  //                     txtName: "教师培训",
  //                     component: loadView("train/index/train-teacher")
  //                 },
  //                 {
  //                     path: "partake",
  //                     name: "partake",
  //                     authName: "partake",
  //                     txtName: "批卷阅卷",
  //                     component: loadView("train/index/train-partake")
  //                 }
  //             ]
  //         },
  //         {
  //             path: "teacher-add",
  //             name: "teacher-add",
  //             authName: "teacher-add",
  //             txtName: "新增培训",
  //             component: loadView("train/index/train-teacher-add")
  //         },
  //         {
  //             path: "teacher-edit",
  //             name: "teacher-edit",
  //             authName: "teacher-edit",
  //             txtName: "培训列表 > 培训管理 >编辑培训",
  //             component: loadView("train/index/train-teacher-edit")
  //         },
  //         {
  //             path: "teacher-detail",
  //             name: "teacher-detail",
  //             authName: "teacher-detail",
  //             txtName: "培训列表 > 培训管理 >编辑培训",
  //             component: loadView("train/index/train-teacher-detail")
  //         },
  //         {
  //             path: "file",
  //             name: "file",
  //             authName: "file",
  //             txtName: "培训列表 > XXX培训>  这是文档名称",
  //             component: loadView("train/index/train-file")
  //         },
  //         {
  //             path: "video",
  //             name: "video",
  //             authName: "video",
  //             txtName: "培训列表 > XXX培训>  这是文档名称",
  //             component: loadView("train/index/train-video")
  //         },
  //         {
  //             path: "statistics",
  //             name: "statistics",
  //             authName: "statistics",
  //             txtName: "培训列表 > 培训管理 > 统计",
  //             component: loadView("train/index/train-teacher-statistics")
  //         },
  //         {
  //             path: "review",
  //             name: "review",
  //             authName: "review",
  //             txtName: "培训列表 > 培训管理 > 批阅",
  //             component: loadView("train/index/train-teacher-review")
  //         },
  //         {
  //             path: "paper",
  //             name: "paper",
  //             authName: "paper",
  //             txtName: "培训列表 > 培训管理 > 作答试卷",
  //             component: loadView("train/index/train-test-paper")
  //         },
  //         {
  //             path: "test-detail",
  //             name: "test-detail",
  //             authName: "test-detail",
  //             txtName: "培训列表 > 培训管理 > 作答试卷",
  //             component: loadView("train/index/train-test-detail")
  //         },
  //         {
  //             path: "test-review",
  //             name: "test-review",
  //             authName: "test-review",
  //             txtName: "培训列表 > 培训管理 > 批阅 > xxx的答题试卷批阅",
  //             component: loadView("train/index/train-test-review")
  //         },
  //         {
  //             path: "test-see",
  //             name: "test-see",
  //             authName: "test-see",
  //             txtName: "培训列表 > 培训管理 > 批阅 > xxx的答题试卷查看",
  //             component: loadView("train/index/train-test-see")
  //         },
  //         {
  //             path: "test-see2",
  //             name: "test-see2",
  //             authName: "test-see2",
  //             txtName: "培训列表 > 培训管理 > 批阅 > xxx的答题试卷查看",
  //             component: loadView("train/index/train-test-see2")
  //         },
  //         {
  //             path: "batch",
  //             name: "batch",
  //             authName: "batch",
  //             txtName: "批卷阅卷",
  //             component: loadView("train/index/train-list"),
  //             children: [
  //                 {
  //                     path: "index",
  //                     name: "index",
  //                     authName: "index",
  //                     txtName: "批卷阅卷",
  //                     component: loadView("train/index/train-batch")
  //                 }
  //             ]
  //         }
  //     ]
  // },
  // //评课排课
  // {
  //     path: "/course",
  //     name: "course",
  //     authName: "course",
  //     txtName: "评课排课",
  //     component: loadView("course/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "list",
  //             authName: "list",
  //             txtName: "排课列表",
  //             showNav: true,
  //             childrenNode: ["live"],
  //             component: loadView("course/index/list")
  //         },
  //         {
  //             path: "live",
  //             name: "live",
  //             authName: "live",
  //             txtName: "直播",
  //             component: loadView("course/index/live")
  //         },
  //         {
  //             path: "reservation",
  //             name: "reservation",
  //             authName: "reservation",
  //             showNav: true,
  //             childrenNode: ["add", "edit", "entry"],
  //             txtName: "我的预约",
  //             component: loadView("course/index/my-reservation")
  //         },
  //         {
  //             path: "add",
  //             name: "add",
  //             authName: "add",
  //             txtName: "新建预约",
  //             component: loadView("course/index/my-reservation-add")
  //         },
  //         {
  //             path: "edit",
  //             name: "edit",
  //             authName: "edit",
  //             txtName: "预约编辑",
  //             component: loadView("course/index/my-reservation-edit")
  //         },
  //         {
  //             path: "entry",
  //             name: "entry",
  //             authName: "entry",
  //             txtName: "录入课前资料",
  //             component: loadView("course/index/my-reservation-entry")
  //         },
  //         {
  //             path: "reflect",
  //             name: "reflect",
  //             authName: "reflect",
  //             showNav: true,
  //             childrenNode: ["reflect-add", "reflect-edit"],
  //             txtName: "教学反思",
  //             component: loadView("course/index/reflect")
  //         },
  //         {
  //             path: "reflect-add",
  //             name: "reflect-add",
  //             authName: "reflect-add",
  //             txtName: "录入反思",
  //             component: loadView("course/index/reflect-add")
  //         },
  //         {
  //             path: "reflect-edit",
  //             name: "reflect-edit",
  //             authName: "reflect-edit",
  //             txtName: "录入反思",
  //             component: loadView("course/index/reflect-edit")
  //         },
  //         {
  //             path: "excellent",
  //             name: "excellent",
  //             authName: "excellent",
  //             showNav: true,
  //             childrenNode: ["video"],
  //             txtName: "精品课程",
  //             component: loadView("course/index/excellent-course")
  //         },
  //         {
  //             path: "video",
  //             name: "video",
  //             authName: "video",
  //             txtName: "精品课程",
  //             component: loadView("course/index/video")
  //         },
  //         {
  //             path: "class",
  //             name: "class",
  //             showNav: true,
  //             authName: "class",
  //             childrenNode: [
  //                 "video",
  //                 "class-list",
  //                 "class-list-add",
  //                 "class-list-edit"
  //             ],
  //             txtName: "公开课评级",
  //             component: loadView("course/index/class")
  //         },
  //         {
  //             path: "class-list",
  //             name: "class-list",
  //             authName: "class-list",
  //             txtName: "评级列表",
  //             component: loadView("course/index/class-list")
  //         },
  //         {
  //             path: "class-list-add",
  //             name: "add",
  //             authName: "class-list-add",
  //             txtName: "新增评级列表",
  //             component: loadView("course/index/class-list-add")
  //         },
  //         {
  //             path: "class-list-edit",
  //             name: "edit",
  //             authName: "class-list-edit",
  //             pAuthName: "class",
  //             txtName: "编辑评级列表",
  //             component: loadView("course/index/class-list-edit")
  //         }
  //     ]
  // },
  // // 圈组
  // {
  //     path: "/group",
  //     name: "group",
  //     authName: "group",
  //     txtName: "圈组首页",
  //     component: loadView("group/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "index",
  //             authName: "index",
  //             txtName: "圈组列表页",
  //             component: loadView("group/index/group-list")
  //         },
  //         {
  //             path: "introduct",
  //             name: "introduct",
  //             authName: "introduct",
  //             txtName: "圈组介绍",
  //             component: loadView("group/index/group-introduction")
  //         },
  //         {
  //             path: "postsList",
  //             name: "postsList",
  //             authName: "postsList",
  //             txtName: "帖子列表",
  //             component: loadView("group/index/group-posts-list")
  //         },
  //         {
  //             path: "postEdit",
  //             name: "postEdit",
  //             authName: "postEdit",
  //             txtName: "帖子编辑页",
  //             component: loadView("group/index/group-post-edit")
  //         },
  //         {
  //             path: "postDetails",
  //             name: "postDetails",
  //             authName: "postDetails",
  //             txtName: "帖子详情",
  //             component: loadView("group/index/group-post-details")
  //         },
  //         {
  //             path: "manage",
  //             name: "manage",
  //             authName: "manage",
  //             txtName: "圈组管理",
  //             component: loadView("group/index/group-manage"),
  //             children: [
  //                 {
  //                     path: "selfCreated",
  //                     name: "selfCreated",
  //                     authName: "selfCreated",
  //                     txtName: "我创建的圈组",
  //                     component: loadView("group/index/group-selfCreated")
  //                 },
  //                 {
  //                     path: "approval",
  //                     name: "approval",
  //                     authName: "approval",
  //                     txtName: "成员审批",
  //                     component: loadView("group/index/group-member-approval")
  //                 },
  //                 {
  //                     path: "iJoin",
  //                     name: "iJoin",
  //                     authName: "iJoin",
  //                     txtName: "我加入的圈组",
  //                     component: loadView("group/index/group-i-join")
  //                 },
  //                 {
  //                     path: "inviteMe",
  //                     name: "inviteMe",
  //                     authName: "inviteMe",
  //                     txtName: "邀请我的圈组",
  //                     component: loadView("group/index/group-invite-me")
  //                 }
  //             ]
  //         },
  //         {
  //             path: "manageOne",
  //             name: "manageOne",
  //             authName: "manageOne",
  //             txtName: "管理一个圈组",
  //             component: loadView("group/index/group-manage-one")
  //         },
  //         {
  //             path: "groupAdd",
  //             name: "groupAdd",
  //             authName: "groupAdd",
  //             txtName: "创建圈组",
  //             component: loadView("group/index/group-add")
  //         }
  //     ]
  // },
  // // 大数据
  // {
  //     path: "/statistic",
  //     name: "statistic",
  //     authName: "statistic",
  //     txtName: "大数据统计",
  //     component: loadView("statistic/base/main"),
  //     children: [
  //         {
  //             path: "user",
  //             name: "user",
  //             authName: "user",
  //             txtName: "用户",
  //             component: loadView("statistic/index/user")
  //         },
  //         {
  //             path: "resources",
  //             name: "resources",
  //             authName: "resources",
  //             txtName: "资源",
  //             component: loadView("statistic/index/resources")
  //         },
  //         {
  //             path: "application",
  //             name: "application",
  //             authName: "application",
  //             txtName: "应用",
  //             component: loadView("statistic/index/application")
  //         },
  //         {
  //             path: "research",
  //             name: "research",
  //             authName: "research",
  //             txtName: "教研活动",
  //             component: loadView("statistic/index/research")
  //         }
  //     ]
  // },
  // //巡课
  {
    path: "/inspection",
    name: "inspection",
    authName: "inspection",
    txtName: "巡课-首页",
    component: loadView("inspection/base/main"),
    children: [
      {
        path: "/",
        name: "index",
        authName: "index",
        txtName: "巡课-首页",
        component: loadView("inspection/index/index"),
      },
      {
        path: "play",
        name: "play",
        authName: "play",
        txtName: "巡课-播放",
        component: loadView("inspection/index/play"),
      },
    ],
  },
  // // 邮箱
  // {
  //     path: "/email",
  //     name: "email",
  //     authName: "email",
  //     txtName: "邮箱",
  //     component: loadView("email/base/main"),
  //     children: [
  //         {
  //             path: "inbox",
  //             name: "inbox",
  //             authName: "inbox",
  //             txtName: "收件箱",
  //             component: loadView("email/index/inbox")
  //         },
  //         {
  //             path: "drafts",
  //             name: "drafts",
  //             authName: "drafts",
  //             txtName: "草稿箱",
  //             component: loadView("email/index/drafts")
  //         },
  //         {
  //             path: "sent",
  //             name: "sent",
  //             authName: "sent",
  //             txtName: "已发送",
  //             component: loadView("email/index/sent")
  //         },
  //         {
  //             path: "trash",
  //             name: "trash",
  //             authName: "trash",
  //             txtName: "废纸篓",
  //             component: loadView("email/index/trash")
  //         },
  //         {
  //             path: "query",
  //             name: "query",
  //             authName: "query",
  //             txtName: "查询邮件",
  //             component: loadView("email/index/query")
  //         },
  //         {
  //             path: "mail-detail",
  //             name: "mail-detail",
  //             authName: "mail-detail",
  //             txtName: "查询结果",
  //             component: loadView("email/index/mail-detail")
  //         },
  //         {
  //             path: "settings",
  //             name: "settings",
  //             authName: "settings",
  //             txtName: "邮箱设置",
  //             component: loadView("email/index/settings")
  //         },
  //         {
  //             path: "send",
  //             name: "send",
  //             authName: "send",
  //             txtName: "写邮件",
  //             component: loadView("email/index/send")
  //         },
  //         {
  //             path: "reply",
  //             name: "reply",
  //             authName: "reply",
  //             txtName: "回复",
  //             component: loadView("email/index/reply")
  //         },
  //         {
  //             path: "forward",
  //             name: "forward",
  //             authName: "forward",
  //             txtName: "转发",
  //             component: loadView("email/index/forward")
  //         }
  //     ]
  // },
  //名师中心
  // {
  //     path: "/teach",
  //     name: "teach",
  //     authName: "teachcenter",
  //     txtName: "名师中心-首页",
  //     component: loadView("teach/base/main"),
  //     children: [
  //         {
  //             path: "/",
  //             name: "home",
  //             authName: "home",
  //             txtName: "名师中心-首页",
  //             component: loadView("teach/index/index")
  //         },
  //         {
  //             path: "space",
  //             name: "space",
  //             authName: "space",
  //             txtName: "名师-个人空间",
  //             component: loadView("teach/index/space"),
  //             children: [
  //                 {
  //                     path: "",
  //                     name: "video",
  //                     authName: "video",
  //                     txtName: "视频",
  //                     component: loadView("teach/index/video")
  //                 },
  //                 {
  //                     path: "resource",
  //                     name: "resource",
  //                     authName: "resource",
  //                     txtName: "教学资源",
  //                     component: loadView("teach/index/resource")
  //                 },
  //                 {
  //                     path: "journal",
  //                     name: "journal",
  //                     authName: "journal",
  //                     txtName: "视频",
  //                     component: loadView("teach/index/journal")
  //                 },
  //                 {
  //                     path: "fans",
  //                     name: "fans",
  //                     authName: "fans",
  //                     txtName: "粉丝",
  //                     component: loadView("teach/index/fans")
  //                 },
  //                 {
  //                     path: "follow",
  //                     name: "follow",
  //                     authName: "follow",
  //                     txtName: "关注",
  //                     component: loadView("teach/index/follow")
  //                 }
  //             ]
  //         },
  //         {
  //             path: "see",
  //             name: "see",
  //             authName: "see",
  //             txtName: "名师中心-首页",
  //             component: loadView("teach/index/journal-detail")
  //         }
  //     ]
  // },
  //备忘录
  // {
  //     path: "/memorandum",
  //     name: "memorandum",
  //     authName: "memorandum",
  //     txtName: "备忘录",
  //     component: loadView("memorandum/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "index",
  //             authName: "index",
  //             txtName: "备忘录",
  //             component: loadView("memorandum/index/index")
  //         },
  //         {
  //             path: "add",
  //             name: "add",
  //             authName: "add",
  //             txtName: "备忘录-新建",
  //             component: loadView("memorandum/index/add")
  //         },
  //         {
  //             path: "edit",
  //             name: "edit",
  //             authName: "edit",
  //             txtName: "备忘录-编辑",
  //             component: loadView("memorandum/index/edit")
  //         },
  //         {
  //             path: "see",
  //             name: "see",
  //             authName: "see",
  //             txtName: "备忘录-编辑",
  //             component: loadView("memorandum/index/see")
  //         }
  //     ]
  // },
  // //协同备课
  // {
  //     path: "/prepare",
  //     name: "prepare",
  //     authName: "prepare",
  //     txtName: "协同备课-首页",
  //     component: loadView("prepare/base/main"),
  //     children: [
  //         {
  //             path: "/",
  //             name: "index",
  //             authName: "index",
  //             txtName: "协同备课-个人备课",
  //             component: loadView("prepare/index/index"),
  //             children: [
  //                 {
  //                     path: "/",
  //                     name: "personal",
  //                     authName: "personal",
  //                     txtName: "协同备课-个人备课",
  //                     component: loadView("prepare/index/prepare-personal")
  //                 },
  //                 {
  //                     path: "collective",
  //                     name: "collective",
  //                     authName: "collective",
  //                     txtName: "协同备课-集体备课",
  //                     component: loadView("prepare/index/prepare-collective")
  //                 }
  //             ]
  //         },

  //         {
  //             path: "add",
  //             name: "add",
  //             authName: "add",
  //             txtName: "协同备课-新建",
  //             component: loadView("prepare/index/prepare-add")
  //         },
  //         {
  //             path: "edit",
  //             name: "edit",
  //             authName: "edit",
  //             txtName: "协同备课-编辑",
  //             component: loadView("prepare/index/prepare-edit")
  //         },
  //         {
  //             path: "task",
  //             name: "task",
  //             authName: "task",
  //             txtName: "协同备课-任务",
  //             component: loadView("prepare/index/prepare-task")
  //         },
  //         {
  //             path: "task-add",
  //             name: "task-add",
  //             authName: "task-add",
  //             txtName: "协同备课-任务",
  //             component: loadView("prepare/index/prepare-task-add")
  //         },
  //         {
  //             path: "resource",
  //             name: "resource",
  //             authName: "resource",
  //             txtName: "协同备课-个人备课",
  //             component: loadView("prepare/index/prepare-resource")
  //         },
  //         {
  //             path: "video",
  //             name: "video",
  //             authName: "video",
  //             txtName: "协同备课-视频",
  //             component: loadView("prepare/index/prepare-video")
  //         },
  //         {
  //             path: "test",
  //             name: "test",
  //             authName: "test",
  //             txtName: "协同备课-试卷",
  //             component: loadView("prepare/index/prepare-test")
  //         },
  //         {
  //             path: "see",
  //             name: "see",
  //             authName: "see",
  //             txtName: "协同备课-查看",
  //             component: loadView("prepare/index/prepare-see")
  //         }
  //     ]
  // },
  // // AI分析
  // {
  //     path: "/analysis",
  //     name: "analysis",
  //     authName: "analysis",
  //     txtName: "AI分析首页",
  //     component: loadView("analysis/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "class",
  //             authName: "class",
  //             txtName: "课堂分析",
  //             component: loadView("analysis/index/AI-class")
  //         },
  //         {
  //             path: "report",
  //             name: "report",
  //             authName: "report",
  //             txtName: "观察报告",
  //             component: loadView("analysis/index/AI-report")
  //         },
  //         {
  //             path: "compare-class",
  //             name: "compare-class",
  //             authName: "compare-class",
  //             txtName: "授课对比",
  //             component: loadView("analysis/index/AI-compare-class")
  //         },
  //         {
  //             path: "compare-report",
  //             name: "compare-report",
  //             authName: "compare-report",
  //             txtName: "授课对比报告",
  //             component: loadView("analysis/index/AI-compare-report")
  //         },
  //         {
  //             path: "score",
  //             name: "score",
  //             authName: "score",
  //             txtName: "成绩分析",
  //             component: loadView("analysis/index/AI-score")
  //         },
  //         {
  //             path: "attendance",
  //             name: "attendance",
  //             authName: "attendance",
  //             txtName: "无感考勤",
  //             component: loadView("analysis/index/AI-attendance")
  //         }
  //     ]
  // },
  // // 日程协同
  // {
  //     path: "/calendar",
  //     name: "calendar",
  //     authName: "calendar",
  //     txtName: "日程协同",
  //     component: loadView("calendar/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "calendar",
  //             authName: "calendar",
  //             txtName: "日程协同",
  //             component: loadView("calendar/index/calendar")
  //         }
  //     ]
  // },

  // //網絡教研
  // {
  //     path: "/netteach",
  //     name: "netteach",
  //     authName: "netteach",
  //     txtName: "網絡教研",
  //     component: loadView("netteach/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "index",
  //             authName: "index",
  //             txtName: "網絡教研",
  //             component: loadView("netteach/index/index")
  //         },
  //         {
  //             path: "add",
  //             name: "add",
  //             authName: "add",
  //             txtName: "網絡教研-新建",
  //             component: loadView("netteach/index/netteach-add")
  //         },
  //         {
  //             path: "standard",
  //             name: "standard",
  //             authName: "standard",
  //             txtName: "網絡教研-评课标准管理",
  //             component: loadView("netteach/index/netteach-standard")
  //         },
  //         {
  //             path: "standard-edit",
  //             name: "standard-edit",
  //             authName: "standard-edit",
  //             txtName: "網絡教研-评课标准管理",
  //             component: loadView("netteach/index/netteach-standard-edit")
  //         },
  //         {
  //             path: "details",
  //             name: "details",
  //             authName: "details",
  //             txtName: "網絡教研-详情",
  //             component: loadView("netteach/index/netteach-details")
  //         },
  //         {
  //             path: "video",
  //             name: "video",
  //             authName: "video",
  //             txtName: "網絡教研-video",
  //             component: loadView("netteach/index/netteach-video")
  //         }
  //     ]
  // },
  // //校友服务
  // {
  //     path: "/alumni",
  //     name: "alumni",
  //     authName: "alumni",
  //     txtName: "校友服务",
  //     component: loadView("alumni/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "index",
  //             authName: "index",
  //             txtName: "校友服务",
  //             component: loadView("alumni/index/index")
  //         },
  //         {
  //             path: "details",
  //             name: "details",
  //             authName: "details",
  //             txtName: "文章详情",
  //             component: loadView("alumni/index/details")
  //         },
  //         {
  //             path: "news",
  //             name: "news",
  //             authName: "news",
  //             txtName: "文章详情",
  //             component: loadView("alumni/index/news")
  //         },
  //         {
  //             path: "mine",
  //             name: "mine",
  //             authName: "mine",
  //             txtName: "我的相册",
  //             component: loadView("alumni/index/mine")
  //         },
  //         {
  //             path: "built",
  //             name: "built",
  //             authName: "built",
  //             txtName: "我的相册",
  //             component: loadView("alumni/index/built")
  //         },
  //         {
  //             path: "album",
  //             name: "album",
  //             authName: "album",
  //             txtName: "我的相册详情",
  //             component: loadView("alumni/index/album-details")
  //         },
  //     ]
  // },
  // //学籍管理
  // {
  //     path: "/schoolroll",
  //     name: "schoolroll",
  //     authName: "schoolroll",
  //     txtName: "学籍管理",
  //     component: loadView("schoolroll/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "index",
  //             authName: "index",
  //             txtName: "校友服务",
  //             component: loadView("schoolroll/index/index")
  //         },

  //     ]
  // },
  // //办公审批
  // {
  //     path: "/examine",
  //     name: "examine",
  //     authName: "examine",
  //     txtName: "办公审批",
  //     component: loadView("examine/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "index",
  //             authName: "index",
  //             txtName: "审批首页",
  //             component: loadView("examine/index/index")
  //         },
  //         {
  //             path: "detail",
  //             name: "detail",
  //             authName: "detail",
  //             txtName: "审批单详情",
  //             component: loadView("examine/index/examine-detail")
  //         },
  //     ]
  // },
  // //智能组卷
  // {
  //     path: "/test",
  //     name: "test",
  //     authName: "test",
  //     txtName: "智能组卷",
  //     component: loadView("test/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "list",
  //             authName: "list",
  //             txtName: "智能组卷",
  //             component: loadView("test/index/test-list")
  //         },
  //         {
  //             path: "manual",
  //             name: "manual",
  //             authName: "manual",
  //             txtName: "手动组卷",
  //             component: loadView("test/index/manual-test-paper")
  //         },
  //         {
  //             path: "intelligent",
  //             name: "intelligent",
  //             authName: "intelligent",
  //             txtName: "智能组卷",
  //             component: loadView("test/index/intelligent-test-pape")
  //         },
  //         {
  //             path: "intelligent-node",
  //             name: "intelligent-node",
  //             authName: "intelligent-node",
  //             txtName: "智能组卷--节点",
  //             component: loadView("test/index/intelligent-test-pape-node")
  //         },
  //         {
  //             path: "item-bank",
  //             name: "item-bank",
  //             authName: "item-bank",
  //             txtName: "公共题库",
  //             component: loadView("test/index/common-item-bank")
  //         },
  //         {
  //             path: "private-bank",
  //             name: "private-bank",
  //             authName: "private",
  //             txtName: "私人题库",
  //             component: loadView("test/index/private-question-bank")
  //         },
  //         {
  //             path: "private-library",
  //             name: "private-library",
  //             authName: "library-library",
  //             txtName: "我的卷库",
  //             component: loadView("test/index/my-volume-library")
  //         },
  //         {
  //             path: "common-library",
  //             name: "common-library",
  //             authName: "common-library",
  //             txtName: "公共卷库",
  //             component: loadView("test/index/common-volume-library")
  //         },
  //         {
  //             path: "preview-test",
  //             name: "preview-test",
  //             authName: "preview-test",
  //             txtName: "预览试卷",
  //             component: loadView("test/index/in-preview-test-paper")
  //         },
  //         {
  //             path: "knowledge-points",
  //             name: "knowledge-points",
  //             authName: "knowledge-points",
  //             txtName: "知识点组卷",
  //             component: loadView("test/index/knowledge-points")
  //         },
  //         {
  //             path: "test-paper",
  //             name: "test-paper",
  //             authName: "test-paper",
  //             txtName: "私人试卷",
  //             component: loadView("test/index/m-test-paper")
  //         },
  //         {
  //             path: "details",
  //             name: "details",
  //             authName: "details",
  //             txtName: "试卷详情",
  //             component: loadView("test/index/test-details")
  //         }
  //     ]

  // },
  // //智能练习
  // {
  //     path: "/exercises",
  //     name: "exercises",
  //     authName: "exercises",
  //     txtName: "智能练习",
  //     component: loadView("exercises/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "list",
  //             authName: "list",
  //             txtName: "首页",
  //             component: loadView("exercises/index/exercises-list")
  //         },
  //         {
  //             path: "task",
  //             name: "task",
  //             authName: "task",
  //             txtName: "我的作业",
  //             component: loadView("exercises/index/exercises-task")
  //         },
  //         {
  //             path: "task-test",
  //             name: "task-test",
  //             authName: "task-test",
  //             txtName: "我的作业-试卷",
  //             component: loadView("exercises/index/exercises-test")
  //         },
  //         {
  //             path: "task-result",
  //             name: "task-result",
  //             authName: "task-result",
  //             txtName: "试卷结果",
  //             component: loadView("exercises/index/exercises-result")
  //         },
  //         {
  //             path: "test-library",
  //             name: "test-library",
  //             authName: "test-library",
  //             txtName: "做试卷",
  //             component: loadView("exercises/index/exercises-test-library")
  //         },
  //         {
  //             path: "library-result",
  //             name: "library-result",
  //             authName: "library-result",
  //             txtName: "做试卷--结果（已答）",
  //             component: loadView("exercises/index/exercises-library-result")
  //         },

  //         {
  //             path: "wrong",
  //             name: "wrong",
  //             authName: "wrong",
  //             txtName: "错题本",
  //             component: loadView("exercises/index/exercises-wrong-title")
  //         },
  //         {
  //             path: "wrong-exercises",
  //             name: "wrong-exercises",
  //             authName: "wrong-exercises",
  //             txtName: "错题练习",
  //             component: loadView("exercises/index/exercises-wrong-exercises")
  //         },
  //         {
  //             path: "test-exercises",
  //             name: "test-exercises",
  //             authName: "test-exercises",
  //             txtName: "错题练习--试卷",
  //             component: loadView("exercises/index/exercises-test-exercises")
  //         },
  //         {
  //             path: "volume-library",
  //             name: "volume-library",
  //             authName: "volume-library",
  //             txtName: "卷库",
  //             component: loadView("exercises/index/exercises-volume-library")
  //         },
  //         {
  //             path: "test-preview",
  //             name: "test-preview",
  //             authName: "test-preview",
  //             txtName: "试卷预览",
  //             component: loadView("exercises/index/exercises-test-preview")
  //         },

  //     ]
  // },
  // //大数据2
  // {
  //     path: "/bigdata",
  //     name: "bigdata",
  //     authName: "bigdata",
  //     txtName: "大数据",
  //     component: loadView("bigdata/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "home",
  //             authName: "home",
  //             txtName: "首页",
  //             component: loadView("bigdata/index/data-home")
  //         },
  //         {
  //             path: "users",
  //             name: "users",
  //             authName: "users",
  //             txtName: "用户",
  //             component: loadView("bigdata/index/data-users")
  //         },
  //         {
  //             path: "resource",
  //             name: "resource",
  //             authName: "resource",
  //             txtName: "资源",
  //             component: loadView("bigdata/index/data-resource")
  //         },
  //         {
  //             path: "app",
  //             name: "app",
  //             authName: "app",
  //             txtName: "应用",
  //             component: loadView("bigdata/index/data-app")
  //         },
  //         {
  //             path: "activities",
  //             name: "activities",
  //             authName: "activities",
  //             txtName: "教研活动",
  //             component: loadView("bigdata/index/data-activities")
  //         },
  //     ]
  // },
  // // 车辆管理
  // {
  //     path: "/vehicle",
  //     name: "vehicle",
  //     authName: "vehicle",
  //     txtName: "车辆管理",
  //     component: loadView("vehicle/base/main"),
  //     children: [
  //         {
  //             path: "/",
  //             name: "index",
  //             authName: "index",
  //             txtName: "车辆列表",
  //             component: loadView("vehicle/index/vehicle-list")
  //         },
  //         {
  //             path: "detail",
  //             name: "detail",
  //             authName: "detail",
  //             txtName: "车辆详情",
  //             component: loadView("vehicle/index/vehicle-detail")
  //         },
  //     ]
  // },
  // 宿舍管理
  // {
  //     path: "/dormitory",
  //     name: "dormitory",
  //     authName: "dormitory",
  //     txtName: "宿舍管理",
  //     component: loadView("dormitory/base/main"),
  //     children: [
  //         {
  //             path: "/",
  //             name: "index",
  //             authName: "index",
  //             txtName: "宿舍列表",
  //             component: loadView("dormitory/index/dormitory-list")
  //         },
  //         {
  //             path: "detail",
  //             name: "detail",
  //             authName: "detail",
  //             txtName: "访客详情",
  //             component: loadView("dormitory/index/dormitory-detail")
  //         }
  //     ]
  // },
  // 资产管理
  // {
  //     path: "/assetManage",
  //     name: "assetManage",
  //     authName: "assetManage",
  //     txtName: "资产管理",
  //     component: loadView("assetManage/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "assetList",
  //             authName: "assetList",
  //             txtName: "资产列表",
  //             component: loadView("assetManage/index/asset-list")
  //         },
  //         {
  //             path: "detail",
  //             name: "assetDetail",
  //             authName: "assetDetail",
  //             txtName: "资产详情",
  //             component: loadView("assetManage/index/asset-detail")
  //         },
  //         {
  //             path: "data",
  //             name: "assetData",
  //             authName: "assetData",
  //             txtName: "资产大数据",
  //             component: loadView("assetManage/index/asset-data")

  //         },
  //     ]
  // },
  // 食堂菜单
  // {
  //     path: "/canteen",
  //     name: "canteen",
  //     authName: "canteen",
  //     txtName: "食堂菜单",
  //     component: loadView("canteen/base/main"),
  //     children: [
  //         {
  //             path: "/",
  //             name: "index",
  //             authName: "index",
  //             txtName: "菜单列表",
  //             component: loadView("canteen/index/menu-list")
  //         }
  //     ]
  // },
  // 活动赛事
  // {
  //     path: "/events",
  //     name: "events",
  //     authName: "events",
  //     txtName: "活动赛事",
  //     component: loadView("events/base/main"),
  //     children: [
  //         {
  //             path: "",
  //             name: "eventsIndex",
  //             authName: "eventsIndex",
  //             txtName: "赛事首页",
  //             component: loadView("events/index/events-index")
  //         },
  //         {
  //             path: "school",
  //             name: "schoolEvents",
  //             authName: "schoolEvents",
  //             txtName: "校园活动",
  //             component: loadView("events/index/events-school")
  //         },
  //         {
  //             path: "initiate",
  //             name: "initiateEvents",
  //             authName: "initiateEvents",
  //             txtName: "发起活动",
  //             component: loadView("events/index/events-initiate"),
  //             meta: {
  //                 hideNav: true,
  //             }
  //         },
  //         {
  //             path: "sports",
  //             name: "sportsEvents",
  //             authName: "sportsEvents",
  //             txtName: "体育赛事",
  //             component: loadView("events/index/events-sports")
  //         },
  //         {
  //             path: "activitiesDetails",
  //             name: "activitiesDetails",
  //             authName: "activitiesDetails",
  //             txtName: "活动详情",
  //             component: loadView("events/index/activities-details"),
  //             meta: {
  //                 hideNav: true,
  //             }
  //         },
  //         {
  //             path: "registrationList",
  //             name: "registrationList",
  //             authName: "registrationList",
  //             txtName: "报名名单",
  //             component: loadView("events/index/registration-list"),
  //             meta: {
  //                 hideNav: true,
  //             }
  //         },
  //         {
  //             path: "eventsDetails",
  //             name: "eventsDetails",
  //             authName: "eventsDetails",
  //             txtName: "赛事详情",
  //             component: loadView("events/index/events-details"),
  //             meta: {
  //                 hideNav: true,
  //             }
  //         },
  //     ]
  // },
];
